import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        wrapper: {
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: theme.typography.h4.fontSize,
        },
        inputsWrapper: {
            display: 'flex',
        },
        input: {
            alignItems: 'center',
            marginLeft: theme.spacing(1.25),
            marginRight: theme.spacing(1.25),
        },
    }
})
